<template>
  <!-- 这个是编辑项目的页面 -->
  <div class="contain">
    <!-- 这里边是标题和返回 -->
    <div class="title_box">
      <h4>{{ navigationTitle }}</h4>
      <el-button size="small" type="info" @click="backProject">返回</el-button>
    </div>
    <!-- 这里边是一个表单 -->
    <el-form ref="reference" :model="reference" size="small" label-width="80px" label-position="top" :rules="rules">
      <el-card class="box-card">
        <el-form-item label="企业姓名" prop="name">
          <el-col :span="13">
            <el-input v-model="reference.name" placeholder="请输入企业姓名"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="行业细分" prop="i_id">
          <el-col :span="8">
            <el-select v-model="reference.i_id" placeholder="请选择行业细分">
              <el-option v-for="item in IndustriesList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="部门" prop="d_id">
          <el-col :span="8">
            <el-select v-model="reference.d_id" placeholder="请选择部门">
              <el-option v-for="item in SectorList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="职位" prop="p_id">
          <el-col :span="8">
            <el-select v-model="reference.p_id" placeholder="请选择职位">
              <el-option v-for="item in PositionList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="联系人" prop="user_name">
          <el-col :span="8">
            <el-input v-model="reference.user_name" placeholder="请输入联系人姓名"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="联系方式">
          <el-col :span="8">
            <el-input v-model="reference.user_phone" placeholder="请输入联系方式"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-col :span="8">
            <el-input v-model="reference.email" placeholder="请输入邮箱"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="LOGO" prop="logo">
          <el-upload name="file" class="avatar-uploader" :action="action" :show-file-list="false"
            :on-success="handleAvatarSuccess" :data="{ file: 'file', model: '' }" ref="imageUrl">
            <img v-if="imageUrl" :src="imageUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
      </el-card>
      <el-card class="box-card">
        <el-form-item label="产品领域">
          <el-col :span="7">
            <el-input v-model="reference.product_area" placeholder="请输入产品领域"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="办公室地址">
          <el-col :span="24">
            <el-input v-model="reference.address" placeholder="请输入办公室地址(可选填)"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="网址">
          <el-input placeholder="请输入网址（可选填）" v-model="reference.website">
          </el-input>
        </el-form-item>
        <el-form-item label="机构公众号">
          <el-col :span="10">
            <el-input placeholder="请输入机构公众号（可选填）" v-model="reference.account">
            </el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="二维码">
          <el-upload name="file" class="avatar-uploader" :action="action" :show-file-list="false"
            :on-success="qrcodeHandleAvatarSuccess" :data="{ file: 'file', model: '' }" ref="qrcodeUrl">
            <img v-if="qrcodeUrl" :src="qrcodeUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="企业介绍">
          <el-input type="textarea" :rows="5" placeholder="请输入学术任职" v-model="reference.desc">
          </el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input type="textarea" :rows="2" placeholder="请输入备注" v-model="reference.remarks">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" style="background: #484c7f" @click="submitForm('reference')">保存</el-button>
        </el-form-item>
      </el-card>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'editorProject',
  data() {
    return {
      navigationTitle: '添加企业',
      options: [],
      IndustriesList: [],//行业
      SectorList: [],//部门
      PositionList: [],//职位
      action: `https://laravel.gongshicloud.com/api/index/upload`,
      imageUrl: "",
      qrcodeUrl: "",
      reference: {
        id: '', //主键id 有时修改 空时添加
        name: '',//企业名称 
        i_id: '',//行业分类id
        d_id: '',//部门id
        p_id: '',//职位id
        user_name: '',//联系人
        user_phone: '',//联系电话
        logo: '',//log图片 
        account: '',//公众号名称
        email: '',//邮箱
        website: '',//官网地址
        qrcode: '',//二维码
        product_area: '',//产品领域 
        province: '',//省
        city: '',//市 
        county: '',//区
        address: '',//办公地址
        desc: '',//企业介绍
        remarks: '',//备注
        project_id: '',//项目id，在编辑项目时录入专家时传递，信息库添加专家时不需要
      },
      rules: {
        name: [
          { required: true, message: '请输入企业名称', trigger: 'blur' },
        ],
        i_id: [
          { required: true, message: '请选择行业细分', trigger: 'change' },
        ],
        d_id: [
          { required: true, message: '请选择部门', trigger: 'change' },
        ],
        p_id: [
          { required: true, message: '请选择职位', trigger: 'change' },
        ],
        user_name: [
          { required: true, message: '请输入联系人', trigger: 'blur' },
        ],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
        ],
        logo: [
          { required: true, message: '请上传图片', trigger: 'blur' },
        ],
      },
    }
  },
  created() {
    if (this.$route.query.id != "") { this.compileEntry(this.$route.query.type, this.$route.query.id) }
    if (this.$route.query.project_id != '' && this.$route.query.project_id != null && this.$route.query.project_id != undefined) this.reference.project_id = this.$route.query.project_id
    this.getIndustriesList()
    this.getSectorList()
    this.getPositionList()
  },
  methods: {
    //编辑进入页面
    async compileEntry(type, id) {
      this.navigationTitle = '编辑企业'
      const { data: data } = await this.$http.post("info/detail", {
        type,
        id
      })
      this.reference = data.data
      this.imageUrl = data.data.logo
      this.qrcodeUrl = data.data.qrcode
    },
    //获取行业列表
    async getIndustriesList() {
      const { data: data } = await this.$http.post('cate/list', { type: 7 })
      this.IndustriesList = data.data
    },
    //获取部门列表
    async getSectorList() {
      const { data: data } = await this.$http.post('cate/list', { type: 8 })
      this.SectorList = data.data
    },
    //获取职位列表
    async getPositionList() {
      const { data: data } = await this.$http.post('cate/list', { type: 9 })
      this.PositionList = data.data
    },
    //头像图片上传成功 
    handleAvatarSuccess(res, file, fileList) {
      if (res.code != 200) {
        this.$refs.imageUrl.clearFiles()
        this.$message.error(res.message)
        return
      }
      this.$Loading.finish()
      this.imageUrl = URL.createObjectURL(file.raw);
      this.reference.logo = res.data.url
    },
    //二维码图片上传成功
    qrcodeHandleAvatarSuccess(res, file, fileList) {
      if (res.code != 200) {
        this.$refs.qrcodeUrl.clearFiles()
        this.$message.error(res.message)
        return
      }
      this.$Loading.finish()
      this.qrcodeUrl = URL.createObjectURL(file.raw);
      this.reference.qrcode = res.data.url
    },
    // 滚动条定位到第一个校验失败的div的位置
    locateToErr() {
      setTimeout(() => {
        let errorDiv = document.getElementsByClassName('is-error')
        errorDiv[0].scrollIntoView()
      }, 0)
    },
    // 点击提交表单  
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.getInfoCompany()
        } else {
          this.locateToErr()
          return false;
        }
      });
    },
    //提交表单接口
    async getInfoCompany() {
      const { data: data } = await this.$http.post("info/empresa", this.reference)
      this.$message({
        message: data.message,
        type: 'success'
      });
      this.backProject()
    },
    //返回
    backProject() {
      this.$router.back()
    },
  }
}
</script>

<style lang='less' scoped>
.contain {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .title_box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e8e8e8;
    padding-bottom: 16px;
    margin-bottom: 23px;

    h4 {
      font-size: 28px;
      color: #212529;
    }
  }

  .box-card {
    width: 100%;
    flex: 1;
    overflow-y: auto;
    margin-bottom: 40px;
  }

  // 上传图片
  /deep/ .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 66px;
    height: 66px;
    line-height: 66px;
    text-align: center;
  }

  .avatar {
    width: 66px;
    height: 66px;
    display: block;
  }

  // select的样
  .el-select {
    display: block;
  }
}
</style>
